import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import RocketChat from '../../../components/RocketChat/RocketChat';
import Spinner from '../../../components/Spinner/Spinner';

import { Props, TabStatus } from './ConversationTab.model';

import styles from './ConversationTab.module.scss';

const ConversationTab = ({ roomId }: Props) => {
	const [ tabStatus, setTabStatus ] = useState<TabStatus>(TabStatus.Loading);

	return (
		<div className={styles.tabContent}>
			<Spinner spinning={tabStatus === TabStatus.Loading} />
			{tabStatus === TabStatus.Error && <div className={styles.tabError}><FormattedMessage id="errors.tab"/></div>}
			<RocketChat
				roomId={roomId}
				updateChatStatus={(status) => setTabStatus(status)}
			/>
		</div>
	);
}

export default ConversationTab;